module.exports = __webpack_public_path__ + "img/r301.dc5ae06a.png";